import React, { useState, useEffect } from 'react';
import { useCart } from '../../contexts/CartProvider';
import styles from './style.module.scss';
import { Button } from 'antd';
import { FiPlus, FiMinus } from 'react-icons/fi';
import { PiTimerFill } from 'react-icons/pi';
import { useNavigate, Link } from 'react-router-dom'; 
import { MdShoppingCart } from 'react-icons/md';

const DropDownCarrinho = ({ onResetStep, setVisible }) => {
  const { items, removeFromCart, removeItemFromCart, addToCart } = useCart();
  const navigate = useNavigate();

  const handleRemoveItem = (itemId) => {
    const itemToRemove = items.find((item) => item.id === itemId);
    if (itemToRemove) {
      if (itemToRemove.quantidade > 1) {
        removeItemFromCart(itemId, 1);
      } else {
        removeFromCart(itemId);
      }
    }
  };

  const handleAddItem = (item) => {
    addToCart({ ...item, quantidade: 1 });
  };

  const navigateToCart = () => {
    onResetStep();
    setVisible(false);
    navigate('/carrinho');
  };

  return (
    <div className={styles.container}>
      {items.length > 0 && (
        <>
          <div className={styles.header}>
            <h1 className={styles.titleCarrinho}>
              <MdShoppingCart className={styles.cartIcon} />
              Meu Carrinho
            </h1>
            <span className={styles.itemCount}>{items.length} {items.length === 1 ? 'item' : 'itens'}</span>
          </div>
          
          <div className={styles.itemsList}>
            {items.map((item) => (
              <div key={item.addedAt} className={styles.containerCadaBolao}>
                <div className={styles.containerItems}>
                  <div className={styles.itemInfo}>
                    <div className={styles.grupo}>
                      <h1>{item.grupo}</h1>
                      <h2>{item.nome}</h2>
                    </div>
                    <div className={styles.timer}>
                      <BolaoCounter addedAt={item.addedAt} />
                    </div>
                  </div>
                  
                  <div className={styles.quantityControls}>
                    <div className={styles.quantidade}>
                      <Button 
                        className={styles.buttonMinusPlus} 
                        onClick={() => handleRemoveItem(item.id)}
                        size="small"
                      >
                        <FiMinus />
                      </Button>
                      <span className={styles.quantityNumber}>{item.quantidade}</span>
                      <Button 
                        className={styles.buttonMinusPlus} 
                        onClick={() => handleAddItem(item)}
                        size="small"
                      >
                        <FiPlus />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <button onClick={navigateToCart} className={styles.containerConfirmarCompra}>
            <span>Finalizar Compra</span>
            <div className={styles.checkoutArrow}>→</div>
          </button>
        </>
      )}

      {items.length === 0 && (
        <div className={styles.containerVazio}>
          <div className={styles.emptyIcon}>
            <MdShoppingCart />
          </div>
          <h2>Seu carrinho está vazio</h2>
          <p>Que tal dar uma olhada nos nossos bolões?</p>
          <Link to='/'>
            <Button className={styles.buttonBuyCarrinho}>
              <MdShoppingCart className={styles.buttonIcon} />
              Continuar Comprando
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
};

const BolaoCounter = ({ addedAt }) => {
  const countdownDuration = 15 * 60 * 1000;
  const [timeLeft, setTimeLeft] = useState(() => {
    const now = Date.now();
    const elapsed = now - addedAt;
    return countdownDuration - elapsed;
  });

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setTimeout(() => setTimeLeft(timeLeft - 1000), 1000);
      return () => clearTimeout(timerId);
    }
  }, [timeLeft]);

  const minutes = Math.max(0, Math.floor(timeLeft / 60000));
  const seconds = Math.max(0, ((timeLeft % 60000) / 1000).toFixed(0));
  const isUrgent = timeLeft < 5 * 60 * 1000; // Últimos 5 minutos

  return (
    <div className={`${styles.containerTimer} ${isUrgent ? styles.urgent : ''}`}>
      <PiTimerFill className={styles.timerIcon} />
      <span className={styles.timeDisplay}>
        {minutes}:{String(seconds).padStart(2, '0')}
      </span>
    </div>
  );
};

export default DropDownCarrinho;
